import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostEintragCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostEintragCommandService],
  exports: []
})
export class PostEintragCommandServiceModule { }
